<template>
    <section class="hero has-text-centered">
      <div class="hero-body">
        <div class="container">
          <img src="../assets/logo-sopress-noir.png">
          <h2 class="title">Notes de frais</h2>
          <h2 class="subtitle">
            Utilisez <a href="https://admin.sopress.net/sogest" target="_blank">SOGEST</a> pour ouvrir une fiche<br>de notes de frais et envoyer vos justificatifs.
          </h2>
        </div>
      </div>
    </section>	
</template>

<script>
  export default {
    name: 'Accueil'
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Accueil.vue